export default __webpack_public_path__ + "static/media/Order_Management.bcfc824a.png";